var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9V13.1199H16.6061C16.3599 14.4448 15.6212 15.5667 14.5132 16.3211L17.8939 19C19.8636 17.1432 21 14.4159 21 11.1761C21 10.4218 20.9337 9.69637 20.8106 9.00012L11 9Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63392 12L3.83344 12.6228L1 14.8661C2.79945 18.4939 6.48756 21 10.7625 21C13.7151 21 16.1906 20.0097 18 18.3121L14.4508 15.5129C13.4765 16.1798 12.2338 16.5841 10.7625 16.5841C7.91916 16.5841 5.50338 14.6338 4.63839 12.0064L4.63392 12Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21893 6C0.444171 7.35087 0 8.87525 0 10.5C0 12.1247 0.444171 13.6491 1.21893 15C1.21893 15.009 5 12.4077 5 12.4077C4.77273 11.8052 4.63839 11.1663 4.63839 10.4999C4.63839 9.83346 4.77273 9.19455 5 8.59211L1.21893 6Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7171 4.42423C12.3202 4.42423 13.7451 4.98987 14.883 6.0808L18 2.89902C16.11 1.10108 13.656 0 10.7171 0C6.46215 0 2.79104 2.49494 1 6.13131L4.62163 9C5.48247 6.37371 7.88706 4.42423 10.7171 4.42423Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleImg);
export default __webpack_public_path__ + "static/media/Google-img.da013f6e20743d09d1c49dea456e50f9.svg";
export { ForwardRef as ReactComponent };